import { useConnectionCRUDActions } from '@mm/state/actions/ConnectionsCRUDActions';
import { useConnectionsTableActions } from '@mm/state/modules/connectionsTableState/actions';
import { selectCrmsLeadsSent } from '@mm/state/selectors/connectionsSelectors';
import { activeFacebookPageIdSelector } from '@mm/state/selectors/viewSelectors';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import ConnectionsTableGrid from '../../../../connections/components/ConnectionsTableGrid/ConnectionsTableGrid';
import ZapierPanel from '../../../../zapier/panels/ZapierPanel/ZapierPanel';
import { GoHighLevelIntegration } from './components/GoHighLevelIntegrations/GoHighLevelIntegrations';
import { GoogleSheetsIntegration } from './components/GoogleSheetsIntegrations/GoogleSheetsIntegration';
import { KlaviyoIntegrations } from './components/KlaviyoIntegrations/KlaviyoIntegrations';
import { MailchimpIntegration } from './components/MailchimpIntegrations/MailchimpIntegration';
import { SalesForceIntegrations } from './components/SalesForceIntegrations/SalesForceIntegrations';
import { SendlaneIntegrations } from './components/SendlaneIntegrations/SendlaneIntegrations';
import { ShopifyIntegrations } from './components/ShopifyIntegrations/ShopifyIntegrations';
import './NativeIntegrations.scss';

export const NativeIntegrations = () => {
  const { resetState } = useConnectionsTableActions();
  const { retriveCrmsLeadsSent } = useConnectionCRUDActions();
  const activeFbPageId = useSelector(activeFacebookPageIdSelector);
  const crmsLeadsSent = useSelector(selectCrmsLeadsSent);

  useEffect(() => {
    resetState();
  }, [resetState]);

  useEffect(() => {
    if (!crmsLeadsSent) {
      retriveCrmsLeadsSent(activeFbPageId);
    }
  }, []);

  return (
    <div className="native-integrations">
      <KlaviyoIntegrations />
      <ShopifyIntegrations version="connections" />
      <GoogleSheetsIntegration />
      <ZapierPanel />
      <ConnectionsTableGrid />
      <MailchimpIntegration />
      <GoHighLevelIntegration version="connections" />
      <SalesForceIntegrations />
      <SendlaneIntegrations />
    </div>
  );
};
